class Concept {

    constructor() {
        console.log("hello");

        this.resetScene = bind(this.resetScene, this);
        this.progStory = bind(this.progStory, this);
        this.reset = bind(this.reset, this);
        this.btnNextClick = bind(this.btnNextClick, this);
        this.closeConcept = bind(this.closeConcept, this);
        this.openConcept = bind(this.openConcept, this);
        var hash;
        this.$btnConcept = $(".btn-concept");
        this.$concept = $(".sec-concept").eq(0);
        this.$stories = this.$concept.find(".block");
        this.numStory = this.$stories.length;
        this.$btnNext = this.$concept.find(".btn-next");
        this.$btnBack = this.$concept.find(".btn-back");
        this.$btnClose = this.$concept.find(".btn-close");
        this.progLock = false;
        this.$btnConcept.on("click", this.openConcept);
        this.$btnNext.on("click", this.btnNextClick);
        this.$btnClose.on("click", this.closeConcept);
        this.$btnBack.on("click", this.closeConcept);
        this.sceneId = 0;
        this.durSceneIn = 2000;
        hash = location.hash;

        this.openConcept();

        $(".gnav .concept,.foot-gnav .concept").on("click", (function (_this) {
            return function () {
                return setTimeout(_this.openConcept, 100);
            };
        })(this));
    }

    openConcept(){
        var st;
        $("body,html").addClass("modal");
        this.$concept.fadeIn(1000);
        st = this.$stories.eq(0);
        st.delay(700).fadeIn(1000);
        setTimeout((function (_this) {
            return function () {
                return st.find(".catch").removeClass("intro");
            };
        })(this), 1200);
        setTimeout((function (_this) {
            return function () {
                _this.sceneId = 1;
                _this.progStory();
                return _this.$btnNext.removeClass("hide");
            };
        })(this), 3400);
        if (event) {
            return event.preventDefault();
        }
    }

    closeConcept(){
        /*this.$concept.fadeOut(1200);
        setTimeout(this.reset, 1300);
        return location.hash = "";*/

        //let st = this.$stories.eq(this.sceneId);
        //st.fadeOut(this.durSceneIn);
        this.reset();
        this.openConcept();

    }

    btnNextClick(){
        if (!this.progLock) {
            this.progLock = true;
            this.$btnNext.addClass("hide");
            this.sceneId += 1;
            setTimeout((function (_this) {
                return function () {
                    return _this.resetScene(_this.$stories.eq(_this.sceneId(-1)));
                };
            })(this), this.durSceneIn + 100);
            return this.progStory();
        }

    }

    reset(){
        this.$stories.css({
            "display": "none"
        });
        this.$stories.find(".catch").addClass("intro");
        this.$stories.find(".kan").addClass("intro");
        this.$stories.find(".lead").addClass("intro");
        this.$stories.find(".bg").addClass("intro");
        this.$btnBack.css({
            "display": "none"
        });
        return $("body,html").removeClass("modal");
    }

    progStory(){
        var st;
        st = this.$stories.eq(this.sceneId);
        st.fadeIn(this.durSceneIn);
        st.find(".bg").removeClass("intro");
        st.find(".kan").removeClass("intro");
        return setTimeout((function (_this) {
            return function () {
                st.find(".catch").removeClass("intro");
                st.find(".lead").removeClass("intro");
                _this.progLock = false;
                if (_this.sceneId === 4) {
                    return _this.$btnBack.fadeIn(1000);
                } else {
                    return _this.$btnNext.removeClass("hide");
                }
            };
        })(this), 1500);
    }

    resetScene(){
        $story.find(".catch").addClass("intro");
        $story.find(".lead").addClass("intro");
        $story.find(".bg").addClass("intro");
        $story.find(".kan").addClass("intro");
        $story.css({
            "display": "none"
        });
        return this.sceenId = 0;
    }
}

var _concept = new Concept();